import { Navigate } from 'react-router-dom';
import { Spinner } from '@fluentui/react-components';
import { useAuth } from '../hooks/useAuth';

/* MSAL redirect landing route (redirectUri = /auth/callback). The token response hash is
   processed by initializeMsal() in main.tsx; with navigateToLoginRequestUrl=true MSAL then
   returns to the originating page. This component is the safety net: once MSAL is ready it
   sends the user home (or to /welcome if sign-in didn't complete). */
export function AuthCallback() {
  const { isReady, isAuthenticated } = useAuth();

  if (!isReady) {
    return <Spinner label="Completing sign-in…" />;
  }

  return <Navigate to={isAuthenticated ? '/' : '/welcome'} replace />;
}
